import './style.less';

export default function($log, $state) {
  'ngInject';

  const vm = this;
  this.$state = $state;

  this.$onInit = () => {
    $log.debug('$onInit arguments', arguments);
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/nav/index.js